import {
    apiRegister
} from '../../common/api';

import {
    assign,
    isPlain
} from '../../common/utils';
import {
    ERR_REP_OAUTH_ADDRESS
} from '../../common/const';

/*
协议Id 
35
项目 
模块 
方式 
https 
命令（路径） 
/oauth/address/
说明
获取第三方登录链接,获取到链接会包含一个mzcode，这个code可以存储使用方的信息，并能实现最终登录后用户的去向
*/

const oauthAddress = apiRegister('oauthAddress', {
    protoId: 35,
    path: "/oauth/address/",
    formatQuery(query) {
        query = assign({
            makeCookie: 1,
            areaType: 1,
            redirectUrl : location.href
          }, query);
        return query;
    },
    checkResult({
        address
    }) {
        if (!isPlain(address)) {
            return ERR_REP_OAUTH_ADDRESS; // 数据格式非法
        }
        return 0;
    }
});

// 接口
export const oauthAddressLoad = oauthAddress.send;
